export default __webpack_public_path__ + "f9a45d3.png";